angular.module('qkr').directive('taxRateRecord', ['utils', 'appConfig', function(utils, appConfig) {
	return {
		restrict: 'E',
		scope: {
			taxGroup: '='
		},
		template: require('../../directives/tax/tax_rate_record.html'),
		replace: true,
		link(scope, element, attrs, controller) {
			angular.forEach(scope.taxGroup.taxRates, (taxRate) => {
			    const displayName = taxRate.name + ' (';
			    if (utils.getNumberOfDecimalPlaces(taxRate.applicableTaxRate) > 5) {
			        taxRate.displayName = displayName + 'Error)';
			    } else {
                    taxRate.displayName = displayName + (taxRate.applicableTaxRate * 100) + '%)';
			    }
				if (!scope.taxGroup.selectedTaxRate) {
					if (taxRate.theDefault) {
						scope.taxGroup.selectedTaxRate = taxRate;
					}
				}
			});
		}
	};
}]);



// WEBPACK FOOTER //
// ./src/directives/tax/tax_rate_record.js